import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/pick-child',
        name: 'pickChild',
        component: LayoutNoFooter,
        children: [
            {
                path: 'index',
                name: 'pickChildIndex',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/pick-child/index'),
                meta: {
                    title: '接送方式管理',
                    isAuth: true,
                }
            },
            {
                path: 'setting',
                name: 'pickChildSetting',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/pick-child/setting'),
                meta: {
                    title: '接送方式设置',
                    isAuth: true,
                }
            },
        ]
    },
]
